export default __webpack_public_path__ + "static/media/cosmetics-desktop.38392a1a.png";